var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 26.8091C21.5228 26.8091 26 22.3319 26 16.8091C26 11.2862 21.5228 6.80908 16 6.80908C10.4772 6.80908 6 11.2862 6 16.8091C6 22.3319 10.4772 26.8091 16 26.8091ZM15.43 19.7991L20.18 15.0491C20.52 14.7091 20.52 14.1591 20.18 13.8091C19.84 13.4691 19.28 13.4691 18.94 13.8091L14.81 17.9391L13.06 16.1891C12.72 15.8491 12.16 15.8491 11.82 16.1891C11.48 16.5291 11.48 17.0791 11.82 17.4291L14.2 19.7991C14.37 19.9691 14.59 20.0491 14.81 20.0491C15.04 20.0491 15.26 19.9691 15.43 19.7991Z",
    fill: "#130F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4cbff858a6dbafeeba94b2898a50de0b.svg";
export { ForwardRef as ReactComponent };